import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const PlayIcon = _ref => {
  let {
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "currentColor",
    width: size || '40',
    height: size || '40'
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20,37.8378378 C29.8515658,37.8378378 37.8378378,29.8515658 37.8378378,20 C37.8378378,10.1484342 29.8515658,2.16216216 20,2.16216216 C10.1484342,2.16216216 2.16216216,10.1484342 2.16216216,20 C2.16216216,29.8515658 10.1484342,37.8378378 20,37.8378378 Z M20,40 C8.954305,40 0,31.045695 0,20 C0,8.954305 8.954305,0 20,0 C31.045695,0 40,8.954305 40,20 C40,31.045695 31.045695,40 20,40 Z M26.594595,19.6756755 L15.1351351,12.972973 L15.1351351,26.378378 L26.594595,19.6756755 Z",
    id: "path-play"
  })), /*#__PURE__*/React.createElement("g", {
    id: "play-button",
    stroke: "none",
    fill: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Awesome-Icons---slider-+-grid",
    transform: "translate(-768 -876)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/play",
    transform: "translate(768 876)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "play"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-play",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-play"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#path-play"
  }))))));
};
PlayIcon.displayName = 'PlayIcon';
export default PlayIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=PlayIcon.js.map